import React from "react";
import Seo from "../components/comman/Seo";

const Error = () => {
  return (
    <div>
      <Seo title="Page Not Found" robots="noindex,nofollow" />
      <h1>404 Page Not found</h1>
    </div>
  );
};

export default Error;